import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useActividadesEconomicas() {
  const actividadesEconomicas = useQuery({
    queryKey: ["actividade-economicas"],
    queryFn: resourcesService.getActividadesEconomicasPorClase,
  });

  return actividadesEconomicas;
}
